<div
  class="container-fluid custom-list-container h-100 pb-2 pt-2 overflow-auto"
>
  <div>
    <h3 class="txt-bg-blu">Ricerca Analisi</h3>
    <form *ngIf="ready" class="mt-3 fontSizeSmall" [formGroup]="filterForm">
      <div class="form-row mt-2">
        <div class="col">
          <label for="nome_sito">Nome Sito</label>
          <input
            type="text"
            class="form-control"
            placeholder="Nome Sito"
            formControlName="nome_sito"
          />
        </div>
        <!-- Nome Sito Autocomplete -->
        <!-- <div class="col">
          <label class="bold" for="typeahead-basic-nome-sito">Nome Sito Autocomplete</label>
          <input 
              #searchInputNomeSito 
              (selectItem)="onSelectedNomeSito($event)" 
              id="typeahead-basic-nome-sito"
              type="text" 
              class="form-control fontSizeSmall" 
              placeholder="Nome Sito"
              popupClass="w-100" 
              placement="bottom-left" 
              [editable]="false"
              formControlName="nome_sito"
              [inputFormatter]="ngbTypeaheadResultFormatterNomeSito"
              [ngbTypeahead]="searchNomeSito"
              [resultTemplate]="nomeSitoTemplate" />
          <ng-template #nomeSitoTemplate let-r="result" let-t="term">
              <ngb-highlight [result]="ngbTypeaheadResultFormatterNomeSito(r)" [term]="t"></ngb-highlight>
          </ng-template>
        </div> -->

        <div class="col">
          <label class="bold" for="typeahead-basic-piano-lavori"
            >Piano Lavori</label
          >
          <input
            #searchInputPianoLavori
            (selectItem)="onSelectedPianoLavori($event)"
            id="typeahead-basic-piano-lavori"
            type="text"
            class="form-control fontSizeSmall"
            placeholder="Piano Lavori"
            placement="bottom-left"
            [editable]="false"
            formControlName="piano_lavori"
            [inputFormatter]="ngbTypeaheadResultFormatterPianoLavori"
            [ngbTypeahead]="searchPianoLavori"
            [resultTemplate]="pianoLavoriTemplate"
            popupClass="w-100"
          />
          <ng-template #pianoLavoriTemplate let-r="result" let-t="term">
            <ngb-highlight
              [result]="ngbTypeaheadResultFormatterPianoLavori(r)"
              [term]="t"
              class="autocomplete-result"
              [ngbTooltip]="r.name"
              container="body"
            ></ngb-highlight>
          </ng-template>

          <div class="chip-set">
            <div class="chip" *ngFor="let chip of arrayChipsPianoLavori">
              <label for=""> {{ chip }}</label>
              <button (click)="deleteChipsPianoLavori(chip)">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="20px"
                  width="20px"
                  viewBox="0 0 512 512"
                >
                  <path
                    opacity="1"
                    fill="#1E3050"
                    d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div class="col">
          <label for="anno_piano_lavori">Anno Piano Lavori</label>
          <input
            type="text"
            class="form-control"
            placeholder="Anno Piano Lavori"
            formControlName="anno_piano_lavori"
          />
        </div>
        <div class="col">
          <label for="sr">SR</label>
          <input
            type="text"
            class="form-control"
            placeholder="SR"
            formControlName="sr"
          />
        </div>
      </div>

      <div class="form-row mt-1">
        <div class="col mx-2">
          <label for="">Altezza Centro Elettrico (m)</label>
          <div class="row">
            <div class="col pl-2 pr-0">
              <input
                type="number"
                class="form-control fontSizeSmall"
                placeholder="Min."
                formControlName="altezza_centro_elettrico_min"
              />
            </div>
            <div class="col pl-1 pr-2">
              <input
                type="number"
                class="form-control fontSizeSmall"
                placeholder="Max."
                formControlName="altezza_centro_elettrico_max"
              />
            </div>
          </div>
        </div>

        <div class="col mx-2">
          <label for="">Raggio Area di Ricerca (m)</label>
          <div class="row">
            <div class="col pl-2 pr-0">
              <input
                type="number"
                class="form-control fontSizeSmall"
                placeholder="Min."
                formControlName="raggio_area_di_ricerca_min"
              />
            </div>
            <div class="col pl-1 pr-2">
              <input
                type="number"
                class="form-control fontSizeSmall"
                placeholder="Max."
                formControlName="raggio_area_di_ricerca_max"
              />
            </div>
          </div>
        </div>

        <!-- @author Giulia Briscolini -->
        <!-- IW-134   -->

        <div class="col-4">
          <label class="bold" for="typeahead-basic-group">Gruppo</label>
          <input
            #searchInputGroup
            (selectItem)="onSelectedGroup($event)"
            id="typeahead-basic-group"
            type="text"
            class="form-control fontSizeSmall"
            placeholder="Gruppo"
            popupClass="w-100"
            placement="bottom-left"
            [editable]="false"
            formControlName="gruppo"
            [inputFormatter]="ngbTypeaheadResultFormatterGroup"
            [ngbTypeahead]="searchGroup"
            [resultTemplate]="groupTemplate"
          />
          <ng-template #groupTemplate let-r="result" let-t="term">
            <ngb-highlight
              [result]="ngbTypeaheadResultFormatterGroup(r)"
              [term]="t"
              class="autocomplete-result"
              [ngbTooltip]="r.name"
              container="body"
            ></ngb-highlight>
          </ng-template>

          <div class="chip-set">
            <div class="chip" *ngFor="let chip of arrayChipsGroups">
              <label for=""> {{ chip.name }}</label>
              <button (click)="deleteChipsGroups(chip)">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="20px"
                  width="20px"
                  viewBox="0 0 512 512"
                >
                  <path
                    opacity="1"
                    fill="#1E3050"
                    d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="form-row mt-1">
        <div class="col">
          <label for="codice_cliente_1">Codice Cliente 1</label>
          <input
            type="text"
            class="form-control"
            placeholder="Codice Cliente 1"
            formControlName="codice_cliente_1"
          />
        </div>
        <div class="col">
          <label for="codice_cliente_2">Codice Cliente 2</label>
          <input
            type="text"
            class="form-control"
            placeholder="Codice Cliente 2"
            formControlName="codice_cliente_2"
          />
        </div>
        <div class="col">
          <label for="codice_cliente_3">Codice Cliente 3</label>
          <input
            type="text"
            class="form-control"
            placeholder="Codice Cliente 3"
            formControlName="codice_cliente_3"
          />
        </div>
      </div>

      <div class="form-row mt-1">
        <div class="col">
          <label class="bold" for="typeahead-basic-comune">Comune</label>
          <input
            #searchInputComune
            (selectItem)="onSelectedComune($event)"
            id="typeahead-basic-comune"
            type="text"
            class="form-control fontSizeSmall"
            placeholder="Comune"
            popupClass="w-100"
            placement="bottom-left"
            [editable]="false"
            formControlName="comune"
            [inputFormatter]="ngbTypeaheadResultFormatterComune"
            [ngbTypeahead]="searchComune"
            [resultTemplate]="comuneTemplate"
          />
          <ng-template #comuneTemplate let-r="result" let-t="term">
            <ngb-highlight
              [result]="ngbTypeaheadResultFormatterComune(r)"
              [term]="t"
              class="autocomplete-result"
              [ngbTooltip]="r.name"
              container="body"
            ></ngb-highlight>
          </ng-template>
          <div class="chip-set">
            <div class="chip" *ngFor="let chip of arrayChipsComuni">
              <label for=""> {{ chip }}</label>
              <button (click)="deleteChipsComuni(chip)">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="20px"
                  width="20px"
                  viewBox="0 0 512 512"
                >
                  <!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2023 Fonticons, Inc.-->
                  <path
                    opacity="1"
                    fill="#1E3050"
                    d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div class="col">
          <label class="bold" for="typeahead-basic-provincia">Provincia</label>
          <input
            #searchInputProvincia
            (selectItem)="onSelectedProvincia($event)"
            id="typeahead-basic-provincia"
            type="text"
            class="form-control fontSizeSmall"
            placeholder="Provincia"
            popupClass="w-100"
            placement="bottom-left"
            [editable]="false"
            formControlName="provincia"
            [inputFormatter]="ngbTypeaheadResultFormatterProvincia"
            [ngbTypeahead]="searchProvincia"
            [resultTemplate]="provinciaTemplate"
          />
          <ng-template #provinciaTemplate let-r="result" let-t="term">
            <ngb-highlight
              [result]="ngbTypeaheadResultFormatterProvincia(r)"
              [term]="t"
              class="autocomplete-result"
              [ngbTooltip]="r.name"
              container="body"
            ></ngb-highlight>
          </ng-template>
          <div class="chip-set">
            <div class="chip" *ngFor="let chips of arrayChipsProvince">
              <label for=""> {{ chips }}</label>
              <button (click)="deleteChipsProvince(chips)">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="20px"
                  width="20px"
                  viewBox="0 0 512 512"
                >
                  <!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2023 Fonticons, Inc.-->
                  <path
                    opacity="1"
                    fill="#1E3050"
                    d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div class="col">
          <label class="bold" for="typeahead-basic-regione">Regione</label>
          <input
            #searchInputRegione
            (selectItem)="onSelectedRegione($event)"
            id="typeahead-basic-regione"
            type="text"
            class="form-control fontSizeSmall"
            placeholder="Regione"
            popupClass="w-100"
            placement="bottom-left"
            [editable]="false"
            formControlName="regione"
            [inputFormatter]="ngbTypeaheadResultFormatterRegione"
            [ngbTypeahead]="searchRegione"
            [resultTemplate]="regioneTemplate"
          />
          <ng-template #regioneTemplate let-r="result" let-t="term">
            <ngb-highlight
              [result]="ngbTypeaheadResultFormatterRegione(r)"
              [term]="t"
              class="autocomplete-result"
              [ngbTooltip]="r.name"
              container="body"
            ></ngb-highlight>
          </ng-template>
          <div class="chip-set">
            <div class="chip" *ngFor="let chips of arrayChipsRegioni">
              <label for=""> {{ chips }}</label>
              <button (click)="deleteChipsRegioni(chips)">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="20px"
                  width="20px"
                  viewBox="0 0 512 512"
                >
                  <!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2023 Fonticons, Inc.-->
                  <path
                    opacity="1"
                    fill="#1E3050"
                    d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="form-row mt-2 d-flex justify-content-between">
        <small class="mt-2 ml-2 text-info my-auto">
          * Inserire almeno un filtro per visualizzare le analisi fitrate sulla
          mappa.
        </small>
        <div class="mt-2 my-auto">
          <button
            (click)="onSubmit()"
            class="btn bg-blu txt-white m-1"
            [disabled]="
              filterForm.invalid &&
              arrayChipsComuni.length == 0 &&
              arrayChipsProvince.length == 0 &&
              arrayChipsRegioni.length == 0 &&
              arrayChipsPianoLavori.length == 0 && 
              arrayChipsGroups.length == 0
            "
          >
            Filtra
          </button>
          <button (click)="onReset()" class="btn btn-dark m-1">Reset</button>
        </div>
      </div>
    </form>
  </div>
  <div>
    <div class="d-flex">
      <button
        (click)="onCallExport()"
        placement="right"
        ngbTooltip="Export delle Analisi Filtrate in Formato CSV"
        class="btn bg-blu txt-white float-end"
      >
        Export CSV
      </button>
    </div>
    <div class="tabella-ricerca-analisi overflow-auto mt-2">
      <ebw-list
      *ngIf="paramsInit"
        class="fontSizeSmall"
        [token]="token"
        [styckTh]="true"
        [rowsPerPageOptions]="rowsPerPageOptions"
        [fontawesomeIcons]="icons"
        [listType]="listType"
        [triggerInitialParams]="listChangedTrigger"
        [initialParamsFilters]="listParamsFilters"
        [restApiPath]="restApiPath"
        [listFields]="listFields"
        requestMethod="POST"
        (actionClicked)="onAction($event)"
        (listLoaded)="onListLoaded($event)"
        (listValues)="onListValues($event)"
        #listComponent
      >
      </ebw-list>
    </div>
  </div>
</div>
